<template>
  <tabs parent="servers">
    <tab
      id="list"
      :name="translate('server.list_of')"
      :href="url+'/list'"
    >
      <ServerList
        :servers="servers"
        :active="active"
        :loading="loading"
        :groups_servers="groups_servers"
        @change_active="change_active"
      />
    </tab>

    <tab
      v-if="$store.getters.getPermissions.permissionGod"
      id="group"
      :name="translate('server.groups')"
      :href="url+'/group'"
    >
      <Groups
        :groups_servers="groups_servers"
        @update_servers_group="get_servers_group"
      />
    </tab>

    <tab
        id="instance_list"
        :name="translate('server.instance_list.title')"
        :href="url+'/instance_list'"
    >
      <InstanceList />
    </tab>

    <tab
        id="instance_groups"
        :name="translate('server.instance_group.title')"
        :href="url+'/instance_groups'"
    >
      <InstanceGroups />
    </tab>
  </tabs>
</template>

<script>
import Groups from './Tabs/Groups/Index.vue'
import ServerList from './Tabs/ServerList/ServerList.vue'
import InstanceList from './Tabs/InstanceList/Index.vue'
import InstanceGroups from './Tabs/InstanceGroups/Index.vue'

import {Tabs, Tab} from 'components/UIComponents/Tabs'

export default {
  name: 'Servers',
  components: {
    Tabs,
    Tab,
    Groups,
    ServerList,
    InstanceList,
    InstanceGroups
  },
  data () {
    return {
      active: false,
      servers: [],
      loading: true,
      groups_servers: []
    }
  },

  computed: {
    url () { return '/server-list' }
  },

  watch:{
    active(){
      this.loading = true
    }
  },

  created() {
    this.get_servers_group()
  },

  methods: {
    get_servers_group(){
      this.$http.v1.getServersGroup( (response) => {
        this.groups_servers = response.data.map((server) => {
          return {...server, edit_name: false}
        })
      })
    },

    change_active(val){
      this.active = val
    }
  },

}
</script>
